import React from "react";
import {GetStatusString, VejledersamtaleStatusEnum} from "../../vejledning/vejledersamtaler/VejledersamtaleStatusEnum";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {
    DashboardUddannelsesplanStatusEnum,
    GetUddannelsesplanStatusString
} from "../../vejledning/uddannelsesplan/DashboardUddannelsesplanStatusEnum";
import classNames from "classnames";
import {ReactTooltip} from "../../../core/components/tooltips/ReactTooltip";

type VejledersamtaleStatusCellProps = {
    status: string;
    cellId: string;
    afholdDato?: string;
}

type VejledersamtaleCellValues = {
    status: string;
    dynamicClass: string;
}
export const VejledningStatusCell = ({status, afholdDato, cellId}: VejledersamtaleStatusCellProps) => {
    const getInfo = (): VejledersamtaleCellValues => {
        switch (status) {
            case GetStatusString(VejledersamtaleStatusEnum.EndnuIkkePlanlagt):
                return {status: Localizer.global_endnuIkkePlanlagt(), dynamicClass: "badge-default"};
            case GetUddannelsesplanStatusString(DashboardUddannelsesplanStatusEnum.EndnuIkkeOprettet):
                return {status: Localizer.global_endnuIkkeOprettet(), dynamicClass: "badge-default"};
            case GetStatusString(VejledersamtaleStatusEnum.Planlagt):
                return {status: Localizer.global_planlagt(), dynamicClass: "badge-info-light"};
            case GetUddannelsesplanStatusString(DashboardUddannelsesplanStatusEnum.Oprettet):
                return {status: Localizer.global_oprettet(), dynamicClass: "badge-info-light"};
            case GetStatusString(VejledersamtaleStatusEnum.Klarmeldt):
            case GetUddannelsesplanStatusString(DashboardUddannelsesplanStatusEnum.Klarmeldt):
                return {status: Localizer.global_klarmeldt(), dynamicClass: "badge-warning"};
            case GetStatusString(VejledersamtaleStatusEnum.Afholdt):
                return {status: Localizer.global_afholdt(), dynamicClass: "success-light"};
            case GetUddannelsesplanStatusString(DashboardUddannelsesplanStatusEnum.Godkendt):
                return {status: Localizer.global_godkendt(), dynamicClass: "success-light"};
            case GetStatusString(VejledersamtaleStatusEnum.OverskredetFrist):
                return {status: Localizer.global_overskredetFrist(), dynamicClass: "badge-danger-light danger-dark"};
            case GetUddannelsesplanStatusString(DashboardUddannelsesplanStatusEnum.OverskredetFrist):
                return {status: Localizer.global_overskredetFrist(), dynamicClass: "badge-danger-light danger-dark"};
            default:
                return {status: "", dynamicClass: "badge-default"};
        }
    }
    const cellInfo = getInfo();

    return (
        <>
            <div id={cellId}
                 className={classNames("badge badge-pill badge-lg font-weight-bold min-w-140", cellInfo.dynamicClass)}>
                {cellInfo.status}
            </div>
            {afholdDato &&
                <ReactTooltip selectId={cellId} place="top">
                    <div>{`${Localizer.global_afholdt()}: ${afholdDato}`}</div>
                </ReactTooltip>
            }
        </>
    );

};
